import * as React from 'react';
import S from './SectionWrapper.styles';
const SectionWrapper = React.forwardRef((props, ref) => {
    const { id, children, layout = 'default', flush = 'none', narrow = false, ...otherProps } = props;
    return (React.createElement(S.Container, { ref: ref, id: id, "data-flush": flush, "data-narrow": narrow, ...otherProps }, renderLayout()));
    function renderLayout() {
        if (layout === 'fullWidth') {
            return children;
        }
        return React.createElement(S.Inner, null, children);
    }
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
